const age = [...Array(65 + 1).keys()].slice(18)

const job = [
  {
    id: 0,
    name: 'なし'
  },
  {
    id: 1,
    name: '1回'
  },
  {
    id: 2,
    name: '2回'
  },
  {
    id: 3,
    name: '3回以上'
  }
]

const changeOverJobsCount = [
  {
    id: 0,
    name: '0回'
  },
  {
    id: 1,
    name: '1回以内'
  },
  {
    id: 2,
    name: '2回以内'
  }
]

const employed =
  [
    {
      id: 0,
      name: '離職中'
    },
    {
      id: 1,
      name: '在職中'
    }
  ]

const prefecturesWhich =
  [
    {
      key: '',
      label: '現住所か希望勤務地いずれか合致'
    },
    {
      key: 'present_address',
      label: '現住所のみ'
    },
    {
      key: 'desired_work_place',
      label: '希望勤務地のみ'
    }
  ]

const occupationOperators =
  [
    {
      key: 'or',
      label: '経験職種か希望職種いずれか合致'
    },
    {
      key: 'and',
      label: '経験職種かつ希望職種すべて合致(and検索)'
    }
  ]

const businessOperators =
  [
    {
      key: 'or',
      label: '経験業種か希望業種いずれか合致'
    },
    {
      key: 'and',
      label: '経験業種かつ希望業種すべて合致(and検索)'
    }
  ]

const scoutResultSort =
  [
    {
      id: 0,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 1,
      name: '会員登録日が新しい順',
      keys: ['member.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 2,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '卒業年月が新しい順',
      keys: ['member.graduatedSchool.yearMonth'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutResultSortScouted =
  [
    {
      id: 0,
      name: '送信日時が新しい順',
      keys: ['member.scout.latestMessage.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '送信日時が古い順',
      keys: ['member.scout.latestMessage.insertDate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 2,
      name: '送信回数が少ない順',
      keys: ['member.scout.messagesCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '送信回数が多い順',
      keys: ['member.scout.messagesCount'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 5,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 6,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 7,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutRecommendedSort =
  [
    {
      id: 0,
      name: 'おすすめ順',
      keys: ['member.priority'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 2,
      name: '会員登録日が新しい順',
      keys: ['member.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 6,
      name: '卒業年月が新しい順',
      keys: ['member.graduatedSchool.yearMonth'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const scoutResultSortExcluded =
  [
    {
      id: 0,
      name: '除外した日時が新しい順',
      keys: ['member.excludedInsertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 1,
      name: '最終ログインが新しい順',
      keys: ['member.recentActionDate', 'member.updateDate'],
      order: 'desc'
    },
    {
      id: 2,
      name: '会員登録日が新しい順',
      keys: ['member.insertDate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 3,
      name: '年齢が低い順',
      keys: ['member.birthdate'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 4,
      name: '年齢が高い順',
      keys: ['member.birthdate'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 5,
      name: '他社からのスカウトが少ない順',
      keys: ['member.approachedCount'],
      order: 'asc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    },
    {
      id: 6,
      name: '卒業年月が新しい順',
      keys: ['member.graduatedSchool.yearMonth'],
      order: 'desc',
      secondKeys: ['member.recentActionDate', 'member.updateDate'],
      secondOrder: 'desc'
    }
  ]
const entryResultSort =
  [
    {
      id: 0,
      name: '応募日時が新しい順',
      keys: ['entry.entryDate'],
      order: 'desc'
    },
    {
      id: 1,
      name: '応募日時が古い順',
      keys: ['entry.entryDate'],
      order: 'asc'
    },
    {
      id: 2,
      name: 'やりとりが新しい順',
      keys: ['entry.message.sendReceiveDateTime', 'entry.entryDate'],
      order: 'desc'
    },
    {
      id: 3,
      name: 'やりとりが古い順',
      keys: ['entry.message.sendReceiveDateTime', 'entry.entryDate'],
      order: 'asc'
    },
    {
      id: 4,
      name: '評価が高い順',
      keys: ['entry.currentSelection.evaluation.id'],
      order: 'asc'
    },
    {
      id: 5,
      name: '年齢が低い順',
      keys: ['entry.user.birthday'],
      order: 'desc'
    },
    {
      id: 6,
      name: '年齢が高い順',
      keys: ['entry.user.birthday'],
      order: 'asc'
    },
    {
      id: 7,
      name: '選考ステータス順',
      keys: ['entry.currentSelection.statusOrder'],
      order: 'asc'
    }
  ]
const bulkRegister = [
  {
    id: 1,
    name: '送信候補へ',
    routeNameKeys: ['scoutSearchResult', 'dashboardTop', 'scoutTop', 'scoutRecommended'],
    isPublishedCheck: false,
    limit: 1000,
    tooltip: '送信候補への振り分けは1回あたり1,000件以内です。'
  },
  {
    id: 2,
    name: '除外者へ',
    routeNameKeys: ['scoutSearchResult', 'scoutCandidate'],
    isPublishedCheck: false,
    limit: 1000,
    tooltip: '除外者への振り分けは1回あたり1,000件以内です。'
  },
  {
    id: 3,
    name: '検索対象に戻す',
    routeNameKeys: ['scoutCandidate', 'scoutExcluded'],
    isPublishedCheck: true,
    limit: 1000,
    tooltip: '検索対象へ戻すのは1回あたり1,000件以内です。'
  },
  {
    id: 4,
    name: 'スカウト',
    routeNameKeys: ['scoutSearchResult', 'scoutCandidate', 'dashboardTop', 'scoutTop', 'scoutRecommended'],
    isPublishedCheck: true,
    isPermission: true,
    limit: 2000,
    tooltip: 'スカウトは1回あたり2,000件以内です。'
  },
  {
    id: 5,
    name: 'スカウト',
    routeNameKeys: ['scoutScouted'],
    isPublishedCheck: true,
    isPermission: true,
    isResend: true,
    limit: 2000,
    tooltip: 'スカウトは1回あたり2,000件以内です。'
  },
  {
    id: 6,
    name: '現在の掲載期間の送信候補にコピー',
    routeNameKeys: ['scoutCandidate', 'scoutScouted'],
    isPublishedCheck: false,
    showCopy: true,
    limit: 1000,
    tooltip: '送信候補への振り分けは1回あたり1,000件以内です。'
  }
]

const searchSkillExperienceRange = [
  {
    id: '0',
    name: '年数不問'
  },
  {
    id: '1',
    name: '1年以上'
  },
  {
    id: '3',
    name: '3年以上'
  }
]

const entrySkillExperienceRange = [
  {
    id: '10',
    name: '年数不問'
  },
  {
    id: '11',
    name: '1年以上'
  },
  {
    id: '12',
    name: '3年以上'
  }
]

const registeredExperienceRange = [
  {
    level: null,
    name: '未経験'
  },
  {
    level: 10,
    name: '1年未満'
  },
  {
    level: 11,
    name: '1年以上3年未満'
  },
  {
    level: 12,
    name: '3年以上'
  }
]

const readingStatus = [
  {
    id: 1,
    name: '既読'
  },
  {
    id: 2,
    name: '未読'
  }
]

const approachedOtherCompany = [
  {
    id: 1,
    name: '10社以内',
    value: '10'
  },
  {
    id: 2,
    name: '30社以内',
    value: '30'
  },
  {
    id: 3,
    name: '49社以内',
    value: '49'
  }
]

const entryBulkUpdate = [
  {
    key: 'pdf_download',
    name: '一括PDFダウンロード',
    optionLabel: '選択した応募者を一括PDFダウンロード',
    permission: 'canPdfDownload'
  },
  {
    key: 'csv_download',
    name: '一括CSVダウンロード',
    optionLabel: '選択した応募者を一括CSVダウンロード'
  },
  {
    key: 'responsible_staffs',
    name: '人事担当',
    optionLabel: '選択した応募者の人事担当を更新'
  },
  {
    key: 'phase_and_status',
    name: '選考フェーズ・ステータス',
    optionLabel: '選択した応募者の選考フェーズ・ステータスを更新'
  },
  {
    key: 'remarks',
    name: '備考',
    optionLabel: '選択した応募者の備考を更新'
  },
  {
    key: 'create_bulk_message',
    name: 'メッセージ一括送信',
    optionLabel: '選択した応募者へメッセージを一括送信',
    permission: 'canSendMessage'
  }
]

const seminarEntryBulkUpdate = [
  {
    key: 'csv_download',
    name: '一括CSVダウンロード',
    optionLabel: '選択した応募者を一括CSVダウンロード'
  },
  {
    key: 'status',
    name: 'ステータス',
    optionLabel: '選択した応募者のステータスを更新'
  },
  {
    key: 'remarks',
    name: '備考',
    optionLabel: '選択した応募者の備考を更新'
  },
  {
    key: 'create_bulk_message',
    name: 'メッセージ一括送信',
    optionLabel: '選択した応募者へメッセージを一括送信'
  }
]

const seminarEntryMessageResponseStatus = [
  {
    id: 1,
    name: '未読',
    status: { isRead: false }
  },
  {
    id: 2,
    name: '未返信',
    status: { isReplied: false }
  },
  {
    id: 3,
    name: '返信済み',
    status: { isReplied: true }
  }
]

// スカウトの時もworking: true, false の場合はこちらを利用して employedの定義を置き換える
const entryEmployed =
  [
    {
      value: false,
      name: '離職中'
    },
    {
      value: true,
      name: '在職中'
    }
  ]

const hasSpecialFavorsOrNot = [
  {
    id: 1,
    name: '有効のみ'
  },
  {
    id: 2,
    name: '有効・無効'
  },
  {
    id: 3,
    name: '特典なし'
  }
]

const married =
  [
    {
      id: 0,
      name: '未婚'
    },
    {
      id: 1,
      name: '既婚'
    }
  ]

const entryMarried =
  [
    {
      value: false,
      name: '未婚'
    },
    {
      value: true,
      name: '既婚'
    }
  ]

const childStatus =
  [
    {
      id: 0,
      name: '子供なし'
    },
    {
      id: 1,
      name: '子供あり'
    }
  ]

const entryChildStatus =
  [
    {
      value: false,
      name: '子供なし'
    },
    {
      value: true,
      name: '子供あり'
    }
  ]

const homeMovingStatus =
  [
    {
      id: 0,
      name: '不可'
    },
    {
      id: 1,
      name: '可能'
    }
  ]

const entryHomeMovingStatus =
  [
    {
      value: false,
      name: '不可'
    },
    {
      value: true,
      name: '可能'
    }
  ]

const defaultEntryDisplayItems = [
  {
    name: '応募日'
  },
  {
    name: '応募者'
  },
  {
    name: '求人'
  },
  {
    name: 'アプローチ状況'
  },
  {
    name: 'メッセージ'
  }
]

// 応募自動返信設定定数
const entryAutoReplyOptions = {
  whetherToUses: [
    {
      value: false,
      label: '利用しない'
    },
    {
      value: true,
      label: '利用する'
    }
  ],
  allReplies: [
    {
      value: false,
      label: '全応募者'
    },
    {
      value: true,
      label: 'スカウト応募者を除く',
      note: '(応募した求人とは、別の求人でスカウトした方も除外となります）'
    }
  ],
  sendImmediatelies: [
    {
      value: true,
      label: '応募完了後に即時送信する',
      sendTimes: []
    },
    {
      value: false,
      label: '設定時刻に送信する',
      sendTimes: [
        {
          value: 9,
          label: '9時'
        },
        {
          value: 12,
          label: '12時'
        },
        {
          value: 15,
          label: '15時'
        },
        {
          value: 18,
          label: '18時'
        }
      ]
    }
  ]
}

const employmentStatuses =
  [
    {
      id: 10,
      name: '正社員',
      iconName: 'icon_company_sei.png'
    },
    {
      id: 11,
      name: '契約社員',
      iconName: 'icon_company_kei.png'
    },
    {
      id: 12,
      name: '派遣社員',
      iconName: 'icon_company_haken.png'
    },
    {
      id: 13,
      name: 'アルバイト',
      iconName: 'icon_company_ar.png'
    },
    {
      id: 14,
      name: '業務委託',
      iconName: 'icon_company_gyou.png'
    },
    {
      id: 15,
      name: 'その他',
      iconName: 'icon_company_hoka.png'
    }
  ]

const realIntentionRegister = {
  career: [
    {
      id: 1,
      name: '新卒'
    },
    {
      id: 2,
      name: '中途'
    }
  ],
  iconNames: [
    'icon-a.png',
    'icon-b.png',
    'icon-c.png',
    'icon-d.png',
    'icon-e.png',
    'icon-f.png',
    'icon-g.png'
  ]
}

const durationTimeMinutes = [30, 60, 90, 120]

// 面接情報系の定義
const jobInterview = {
  paperScreenings: [
    {
      id: 1,
      name: '書類選考あり'
    },
    {
      id: 2,
      name: '書類選考なし'
    }
  ],
  spiTests: [
    {
      id: 5,
      name: '適性検査なし'
    },
    {
      id: 2,
      name: '性格適性のみ'
    },
    {
      id: 3,
      name: '能力試験のみ'
    },
    {
      id: 1,
      name: '性格適性＋能力試験'
    },
    {
      id: 4,
      name: 'その他適性検査'
    }
  ],
  inputWays: [
    {
      id: 1,
      name: '選択式'
    },
    {
      id: 2,
      name: 'フリー入力'
    }
  ],
  genders: [
    {
      id: 1,
      name: '男性'
    },
    {
      id: 2,
      name: '女性'
    }
  ],
  positions: [
    {
      id: 1,
      name: '人事'
    },
    {
      id: 2,
      name: '現場社員'
    },
    {
      id: 5,
      name: '現場責任者'
    },
    {
      id: 4,
      name: '役員'
    },
    {
      id: 3,
      name: '社長'
    }
  ],
  generations: [
    {
      id: 1,
      name: '20代'
    },
    {
      id: 2,
      name: '30代'
    },
    {
      id: 3,
      name: '40代～'
    }
  ],
  requiredTimes: [
    {
      id: 1,
      name: '30分'
    },
    {
      id: 2,
      name: '30分～1時間'
    },
    {
      id: 3,
      name: '1時間～1時間30分'
    },
    {
      id: 4,
      name: '1時間30分～2時間'
    },
    {
      id: 5,
      name: '2時間～2時間30分'
    },
    {
      id: 6,
      name: '3時間'
    }
  ],
  clothes: [
    {
      id: 1,
      name: 'ビジネスカジュアル'
    },
    {
      id: 2,
      name: 'スーツ'
    },
    {
      id: 3,
      name: '服装自由'
    }
  ],
  welcomeQuestionsOptions: [
    {
      id: 1,
      name: '勤務時間について'
    },
    {
      id: 2,
      name: '入社時のキャリアステップについて'
    },
    {
      id: 3,
      name: '休日休暇について'
    },
    {
      id: 4,
      name: 'ライフイベントの対応について'
    },
    {
      id: 5,
      name: '給与・インセンティブについて'
    },
    {
      id: 6,
      name: '産休・育休後の復職について'
    },
    {
      id: 7,
      name: '勤務地について'
    },
    {
      id: 8,
      name: '研修制度について'
    }
  ]
}

const entryMessageReservationCancelReason = [
  {
    id: 1,
    name: '返信済み',
    label: '応募者からメッセージを受信したため、送信予約がキャンセルされました。'
  },
  {
    id: 2,
    name: '退会済み',
    label: '応募者が退会したため、送信予約がキャンセルされました。'
  }
]

export {
  age,
  job,
  changeOverJobsCount,
  employed,
  prefecturesWhich,
  occupationOperators,
  businessOperators,
  scoutResultSort,
  scoutResultSortScouted,
  scoutRecommendedSort,
  scoutResultSortExcluded,
  entryResultSort,
  bulkRegister,
  searchSkillExperienceRange,
  entrySkillExperienceRange,
  registeredExperienceRange,
  readingStatus,
  approachedOtherCompany,
  entryBulkUpdate,
  seminarEntryBulkUpdate,
  seminarEntryMessageResponseStatus,
  hasSpecialFavorsOrNot,
  durationTimeMinutes,
  married,
  entryMarried,
  childStatus,
  entryChildStatus,
  homeMovingStatus,
  entryHomeMovingStatus,
  defaultEntryDisplayItems,
  entryEmployed,
  entryAutoReplyOptions,
  employmentStatuses,
  jobInterview,
  realIntentionRegister,
  entryMessageReservationCancelReason
}
